import moment from 'moment'

const DATE_FORMAT = 'MMM DD, YYYY'
const TIME_FORMAT = 'h:mm A'
const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`

let offset = -5

export function setTimeZoneOffset(newOffset) {
  console.log('In setTimeZoneOffset with', { newOffset })
  offset = newOffset
}

export function getTimeZoneOffset() {
  return offset
}

export function initializeTimeOffset() {
  let offset = new Date().getTimezoneOffset() / -60
  console.log('Setting offset to ', offset)
  setTimeZoneOffset(offset)
}

// Initialize it by default, if needed it can be overridden
initializeTimeOffset()

/**
 * Sets the date (day month year) of the target date based on the fromDate,
 * keeping time the same.
 * Returns new moment instance
 */
function setCalendarDate(date, fromDate) {
  return moment(date)
    .year(fromDate.year())
    .month(fromDate.month())
    .date(fromDate.date())
}

/**
 * Constrains the date so it is between min and max dates
 * Keeping time the same
 */
export function constrainDate(date, min, max) {
  date = parseDate(date)

  if (min) {
    min = moment(min).utc()
    if (date.isBefore(min, 'day')) {
      date = setCalendarDate(date, min)
    }
  }
  if (max) {
    max = parseDate(max).utc()
    if (date.isAfter(max, 'day')) {
      date = setCalendarDate(date, max)
    }
  }

  return dateToString(date)
}

export function dateToString(date) {
  if (typeof date === 'string') {
    date = parseDate(date)
  }
  const wrapped = moment(date)
  wrapped.utcOffset(offset, true)
  return wrapped.toISOString()
}

export function parseDate(dateString) {
  if (typeof dateString === 'undefined' || dateString === null) {
    throw new Error('In parseDate, expected date string but got ' + dateString)
  }

  return moment.parseZone(dateString).utcOffset(offset, false)
}

/**
 * Returns date object, showing correct time, but may have wrong UTC time
 * For display purposes only (in date time picker, for example)
 *
 * @param dateString
 * @returns {Date}
 */
export function getDisplayDate(dateString) {
  return new Date(...parseDate(dateString).toArray())
}

export function formatDate(date, includeTime) {
  return parseDate(date).format(includeTime ? DATE_TIME_FORMAT : DATE_FORMAT)
}

export function formatTime(date) {
  return parseDate(date).format(TIME_FORMAT)
}

export function daysBetween(startDate, endDate) {
  let normalizedStart = parseDate(startDate).startOf('day')
  let normalizedEnd = parseDate(endDate).startOf('day')
  return normalizedEnd.diff(normalizedStart, 'days')
}



// WEBPACK FOOTER //
// ./src/utils/dateUtils.js